import { render, staticRenderFns } from "./CompareItemsItemBox.vue?vue&type=template&id=41ebde0b&"
import script from "./CompareItemsItemBox.vue?vue&type=script&lang=js&"
export * from "./CompareItemsItemBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports